const PCT = [ 25, 50, 75 ]
const CATEGORY = 'JW Player Video'
export default class GAVideoTracker {

	constructor(player) {

		this.player = player
		this.T = 0
		this.registerEvents()
		this.cancel = []
		this.until = []
		this.notice = []

		this.setGlobals()
		this.registerEvents()
	}

	registerEvents() {

		['beforePlay', 'time', 'autostartNotAllowed', 'error', 'playAttemptFailed', 'setupError', 'warning', 'play', 'pause']
			.forEach((item) => {
				this.player.on(item, this.handleEvent.bind(this))
			})
	}

	handleEvent(event) {
		switch(event.type) {
			case 'beforePlay':
				this.beforePlay(event)
				this.player.off(event.type, this.onBeforePlay)
				break;
			case 'time':
				this.time(event)
				break;
			default:
				console.log('got event ', event.type)
		}
	}

	setGlobals() {

		window.gtag = function(hitType, eventType, eventModel) {
			ga('send', {
				hitType: hitType,
				eventCategory: eventModel.event_category,
				eventLabel: eventModel.event_label,
				eventAction: eventModel.event_action,
				nonInteraction: true
			})

			dataLayer.push(arguments)
		}
	}

	beforePlay(event) {
		let dur = this.player.getDuration()/100
		this.duration = dur
		this.title = this.player.getPlaylistItem().title
		this.until = PCT.map( (pct) => [ pct, pct * dur ] )
		console.log("marking percentiles at ", this.until)
	}

	time(t) {

		if(this.until.length <= 0)
			return
		let T= this.T = t.currentTime
		let until = this.until[0]
		let limit = until[1]
		if (T < limit)
			return
		let pct = until[0]
		this.until.shift()
		this.sendEvent({
			hitType: 'event',
			eventCategory: CATEGORY,
			eventAction: pct+'% Milestone Passed',
			eventLabel: this.title
        })
	}

	sendEvent(event) {
		if(window.ga)
			window.ga('send', event)
	}
}
